import React, { useEffect } from "react";
import { useSubheader } from "../../../_metronic/layout";
import {
  RestlessTable,
  RestlessButtonFormatter,
} from "../../../_metronic/layout/components/Table";
import { useDispatch, useSelector } from "react-redux";
import {
  usersFetch,
  reenableUser,
  shadowbanUser,
  promoteToAdmin,
  promoteToVerified,
  cleanErrors,
  cleanStateUsers,
} from "../../../redux/actions/users";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Route } from "react-router-dom";
import UserDetailsDialog from "./RestlessUsersDialog/UserDetailsDialog";
import RestlessModerationModal from "../../../_metronic/layout/components/modeationModal/RestlessModerationModal";
import { disabledUser, kickedUser } from "../../../redux/actions/users";
import RestlessUserDateFormatter from "../../../_metronic/layout/components/Table/RestlessUserDateFormatter";
import RestlessEmailFormatter from "../../../_metronic/layout/components/Table/RestlessEmailFormatter";
import RestlessBooleanFormatter from "../../../_metronic/layout/components/Table/RestlessBooleanFormattear";
import { Alert } from "react-bootstrap";
export const UsersPage = ({ history }) => {
  const dispatch = useDispatch();
  const suhbeader = useSubheader();
  suhbeader.setTitle("Users");

  const {
    users,
    loading,
    error,
    userDisabled,
    userDisabledLoading,
    userKicked,
    userKickedLoading,
    userShadowbanned,
    userShadowbannedLoading,
    error2,
    userToAdmin,
    userToVerified,
    userReenabled
  } = useSelector((state) => ({
    users: state.users2.usersList || [],
    loading: state.users2.listLoading,
    userToVerified: state.users2.userToVerified,
    userToAdmin: state.users2.userToAdmin,
    error: state.users2.error,
    userDisabled: state.users2.userDisabled,
    userDisabledLoading: state.users2.userDisabledLoading,
    userKicked: state.users2.userKicked,
    userReenabled: state.users2.userReenabled,
    userKickedLoading: state.users2.userKickedLoading,
    userShadowbanned: state.users2.userShadowbanned,
    userShadowbannedLoading: state.users2.userShadowbannedLoading,
    error2: state.users2.error,
  }));

  const buttonsArr = [
    {
      onClickFunction: (row) => {
        return usersUIEvents.openDetailUserDialog(row);
      },
      icon: (
        <SVG title="Detail" src={toAbsoluteUrl("/media/svg/icons/Text/Bullet-list.svg")} />
      ),
      title: "Detail"
    },
    {
      onClickFunction: (row) => {
        return usersUIEvents.openModerateUserDialog(row);
      },
      disabled: true,
      icon: (
        <SVG title="Edit Roles" src={toAbsoluteUrl("/media/svg/icons/General/Settings-1.svg")} />
      ),
      title: "Edit Roles"
    },
  ];

  useEffect(() => {
    dispatch(usersFetch());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const columns = [
    {
      dataField: "full_name",
      text: "Member",
      sort: true,
    },
    {
      dataField: "registration_dt",
      text: "Registered on",
      sort: true,
      formatter: RestlessUserDateFormatter,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      formatter: RestlessEmailFormatter
    },
    {
      dataField: "status",
      text: "Role",
      sort: true,
    },
    {
      dataField: "shadowbanned",
      text: "Shadowbanned",
      sort: true,
      formatter: RestlessBooleanFormatter,
    },
    {
      dataField: "action1",
      formatter: RestlessButtonFormatter,
      formatExtraData: {
        buttonsArr: buttonsArr,
      },
    },
  ];

  const usersUIEvents = {
    openDetailUserDialog: (row) => {
      history.push(`/users/${row.id}/details`);
    },
    openModerateUserDialog: (row) => {
      history.push({
        pathname: `/users/${row.id}/moderate`,
        state: { row: row },
      });
    },
  };

  const onSubmit = (values, row) => {
    const user = row.restless_user ? row.restless_user : row;

    if (values.userAction === "REENABLE_ON_SELF") {
      dispatch(reenableUser({ user, reEnableOnSelf: true }));
      history.push("/users");
      return;
    }
    if (values.userAction === "REENABLE_ON_SOCIAL") {
      dispatch(reenableUser({ user, reEnableOnSocial: true }));
      history.push("/users");
      return;
    }
    if (values.moderateUser && values.userAction === "DISABLED_ON_SELF") {
      dispatch(disabledUser({ id: user.id, disableOnSelf: true }));
    }
    if (values.moderateUser && values.userAction === "DISABLED_ON_SOCIAL") {
      dispatch(disabledUser({ id: user.id, disableOnSocial: true }));
    }

    if (values.moderateUser && values.userAction === "KICKEDOUT") {
      dispatch(kickedUser(user.id));
    }

    if (values.userAction === "SHADOWBAN"){
      const data = { shadowban: true}
      dispatch(shadowbanUser(user, data));
    }
    if (values.userAction === "UNSHADOWBANNED"){
      const data = { shadowban: false}
      dispatch(shadowbanUser(user, data));
    }

    if (values.userAction === "ADMIN") {
      dispatch(promoteToAdmin(user.id));
    }

    if (values.userAction === "VERIFIED") {
      dispatch(promoteToVerified(user.id));
    }

    history.push("/users");
  };

  const renderUserModerationStatus = () => {
    return (
      <Alert variant="success" className="text-center" dismissible onClose={() => cleanStateUsers(dispatch)}>
        The user has been moderated succesfully
      </Alert>
    );
  };

  const renderUserUserVerifiedStatus = () => {
    return (
      <Alert variant="success" className="text-center" dismissible onClose={() => cleanStateUsers(dispatch)}>
        The user has been promoted to verified.
      </Alert>
    );
  };

  const renderUserUserAdminStatus = () => {
    return (
      <Alert variant="success" className="text-center" dismissible onClose={() => cleanStateUsers(dispatch)}> 
        The user has been promoted to admin.
      </Alert>
    );
  };

  const renderUserModerationError = () => {
    return (
      <Alert variant="danger" className="text-center" dismissible onClose={() => cleanErrors(dispatch)}>
        Error: {error}
      </Alert>
    );
  };
  
  const renderEnabledUser = () => {
    return (
      <Alert variant="success" className="text-center" dismissible onClose={() => cleanStateUsers(dispatch)}>
        The user has been reenabled.
      </Alert>
    );
  };
  return (
    <>
      {loading ||
      userDisabledLoading ||
      userKickedLoading ||
      userShadowbannedLoading ? (
        <div className="d-flex justify-content-center align-content-center">
          <span className="mx-3 spinner spinner-primary"></span>
        </div>
      ) : (
        <>
          {!error &&
            !error2 &&
            (userDisabled || userKicked || userShadowbanned) &&
            renderUserModerationStatus()}
          {  userToVerified &&
            renderUserUserVerifiedStatus()}
          { userToAdmin &&
            renderUserUserAdminStatus()}
          { userReenabled &&
            renderEnabledUser()}
          {(error || error2) &&
            !userDisabled &&
            !userKicked &&
            !userShadowbanned &&
            renderUserModerationError()}
          <Route path="/users/:id/details">
            {({ history, match }) => (
              <UserDetailsDialog
                show={match != null}
                id={match && match.params.id}
                onHide={() => {
                  history.push("/users");
                }}
              />
            )}
          </Route>
          <Route path="/users/:id/moderate">
            {({ history, match }) => (
              <RestlessModerationModal
                show={match != null}
                id={match && match.params.id}
                row={history.location.state?.row}
                user={true}
                onSubmit={onSubmit}
                onHide={() => {
                  history.push("/users");
                }}
                entityType="User"
              />
            )}
          </Route>
          <RestlessTable data={users} columns={columns} withPagination />
        </>
      )}
    </>
  );
};
